import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const FontFaceObserver = require('fontfaceobserver');

const skyFont = new FontFaceObserver('SkyRegular');
skyFont.load().then(() => {
  document.body.classList.add('sky-font-loaded');
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
